var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGrid = function SvgGrid(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "grid_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 48,
    y: 48,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 20,
    ry: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 288,
    y: 48,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 20,
    ry: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 48,
    y: 288,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 20,
    ry: 20
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 176,
    x: 288,
    y: 288,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    rx: 20,
    ry: 20
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;